import { captureException, captureMessage } from '@canvas/sentry-core';

let didReportMissingSubtle = false;

export async function sha256Hex(buffer: ArrayBuffer): Promise<string | undefined> {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) {
    if (!didReportMissingSubtle) {
      didReportMissingSubtle = true;
      captureMessage('WebCrypto subtle is unavailable; cannot compute sha256', {
        level: 'warning',
        tags: { captureLocation: 'sha256Hex' },
      });
    }

    return undefined;
  }

  try {
    const hashBuffer = await subtle.digest('SHA-256', buffer);
    return [...new Uint8Array(hashBuffer)]
      .map((x) => x.toString(16).padStart(2, '0'))
      .join('');
  } catch (e) {
    captureException(e, { tags: { captureLocation: 'sha256Hex' } });

    return undefined;
  }
}

export async function sha256HexOfBlob(blob: Blob): Promise<string | undefined> {
  try {
    return await sha256Hex(await blob.arrayBuffer());
  } catch {
    return undefined;
  }
}
